<template>
  <div class="selector">
    <!-- エリア選択 -->
    <ul class="selector__tabs">
      <li
        class="selector__tabs__item"
        v-for="area in data.areas"
        :key="area.id"
      >
        <button
          :class="area.id === selectedArea.id && 'is-current'"
          @click="changeArea(area)"
        >
          <span>
            <ThumbAreaMark :name="area.slug" :current="area.id === selectedArea.id" />
          </span>
          {{ area.name }}
        </button>
      </li>
    </ul>
    <!-- パーツ選択 -->
    <ul class="selector__subTabs">
      <li
        class="selector__subTabs__item"
        v-for="part in currentParts"
        :key="part.id"
      >
        <button
          :class="`${ isPartSelected(part) && 'is-selected' }`"
          @click="handleChangePart(part)"
        >
          <span>
            <ThumbPartMark :name="part.slug" :current="isPartSelected(part)" />
          </span>
          {{ part.name }}
        </button>
      </li>
    </ul>
    <div class="selector__wrapper">
      <div class="selector__container">
        <!-- エレメント選択 -->
        <div class="items items--markElements" v-if="currentElements.length">
          <div class="items__item" v-for="element in currentElements" :key="element.id">
            <button
              :class="`items__button ${ isElementSelected(element) && 'is-selected' }`"
              @click="handleChangeElement(element)"
            >
              <span class="items__thumb"><MarkElementImage :name="element.slug" /></span>
              <span class="items__name">{{ element.name }}</span>
            </button>
          </div>
        </div>
        <!-- レイヤー1： 胸 - マーク -->
        <template v-if="selectedArea.slug === 'chest' && isContainPartSlug('chest_mark')">
          <div v-if="isContainElementSlug('both_sides')" class="items items--markBothSidesItems">
            <div class="items__item" v-for="item in chestMarkBothSidesItems" :key="item.id">
              <button
                @click="changeChestItem(item)"
                :class="`items__button ${ item.id === selectedChestItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><MarkChestBothSidesItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <div v-if="isContainElementSlug('one_side')" class="items items--markOneSideItems">
            <div class="items__item" v-for="item in chestMarkOneSideItems" :key="item.id">
              <button
                @click="changeChestItem(item)"
                :class="`items__button ${ item.id === selectedChestItem.id && 'is-selected' }`"
                :style="{ backgroundColor: item.background_color }"
              >
                <span class="items__thumb"><MarkChestOneSideItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <section v-if="selectedChestItem.color1"  class="selectorSection">
            <h3 class="selectorSection__name">カラー1</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedChestItemColor1 === 'transparent' && 'is-selected' }`"
                  @click="changeChestItemColor1('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedChestItemColor1 === color && 'is-selected' }`"
                  @click="changeChestItemColor1(color)"
                >
                </button>
              </div>
            </div>
          </section>
          <section v-if="selectedChestItem.color2"  class="selectorSection">
            <h3 class="selectorSection__name">カラー2</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedChestItemColor2 === 'transparent' && 'is-selected' }`"
                  @click="changeChestItemColor2('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedChestItemColor2 === color && 'is-selected' }`"
                  @click="changeChestItemColor2(color)"
                >
                </button>
              </div>
            </div>
          </section>
          <section v-if="selectedChestItem.color3"  class="selectorSection">
            <h3 class="selectorSection__name">カラー3</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedChestItemColor3 === 'transparent' && 'is-selected' }`"
                  @click="changeChestItemColor3('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedChestItemColor3 === color && 'is-selected' }`"
                  @click="changeChestItemColor3(color)"
                >
                </button>
              </div>
            </div>
          </section>
        </template>
        <!-- レイヤー2： 胸 - 番号 -->
        <template v-if="selectedArea.slug === 'chest' && isContainPartSlug('chest_number')">
          <div class="items items--markChestNumberItems">
            <div class="items__item" v-for="item in chestNumberItems" :key="item.id">
              <button
                @click="changeChestNumberItem(item)"
                :class="`items__button ${ item.id === selectedChestNumberItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><MarkNumberItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <section class="selectorSection">
            <h3 class="selectorSection__name">カラー1</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedChestNumberItemColor1 === 'transparent' && 'is-selected' }`"
                  @click="changeChestNumberItemColor1('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedChestNumberItemColor1 === color && 'is-selected' }`"
                  @click="changeChestNumberItemColor1(color)"
                >
                </button>
              </div>
            </div>
          </section>
        </template>
        <!-- レイヤー3： 背面 - 番号 -->
        <template v-if="selectedArea.slug === 'back' && isContainPartSlug('back_number')">
          <div class="items items--markBackNumberItems">
            <div class="items__item" v-for="item in backNumberItems" :key="item.id">
              <button
                @click="changeBackNumberItem(item)"
                :class="`items__button ${ item.id === selectedBackNumberItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><MarkNumberItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <section class="selectorSection">
            <h3 class="selectorSection__name">カラー1</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBackNumberItemColor1 === 'transparent' && 'is-selected' }`"
                  @click="changeBackNumberItemColor1('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedBackNumberItemColor1 === color && 'is-selected' }`"
                  @click="changeBackNumberItemColor1(color)"
                >
                </button>
              </div>
            </div>
          </section>
        </template>
        <!-- レイヤー4： 背面 - ネーム -->
        <template v-if="selectedArea.slug === 'back' && isContainPartSlug('back_name')">
          <div class="items items--markBackNameItems">
            <div class="items__item" v-for="item in backNameItems" :key="item.id">
              <button
                @click="changeBackItem(item)"
                :class="`items__button ${ item.id === selectedBackItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><MarkBackNameItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <section class="selectorSection">
            <h3 class="selectorSection__name">カラー1</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedBackItemColor1 === 'transparent' && 'is-selected' }`"
                  @click="changeBackItemColor1('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedBackItemColor1 === color && 'is-selected' }`"
                  @click="changeBackItemColor1(color)"
                >
                </button>
              </div>
            </div>
          </section>
        </template>
        <!-- レイヤー5： 袖マーク -->
        <template v-if="selectedArea.slug === 'sleeve'">
          <div v-if="isContainElementSlug('japanese')" class="items items--markSleeveJapaneseItems">
            <div class="items__item" v-for="item in sleeveJapaneseItems" :key="item.id">
              <button
                @click="changeSleeveItem(item)"
                :class="`items__button ${ item.id === selectedSleeveItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><MarkSleeveJapaneseItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <div v-if="isContainElementSlug('english')" class="items items--markSleeveEnglishItems">
            <div class="items__item" v-for="item in sleeveEnglishItems" :key="item.id">
              <button
                @click="changeSleeveItem(item)"
                :class="`items__button ${ item.id === selectedSleeveItem.id && 'is-selected' }`"
              >
                <span class="items__thumb"><MarkSleeveEnglishItemImage :name="item.slug" /></span>
              </button>
            </div>
          </div>
          <section class="selectorSection">
            <h3 class="selectorSection__name">カラー1</h3>
            <div class="items items--colors">
              <div class="items__item">
                <button
                  :class="`items__button is-none ${ selectedSleeveItemColor1 === 'transparent' && 'is-selected' }`"
                  @click="changeSleeveItemColor1('transparent')"
                >
                  <span>なし</span>
                </button>
              </div>
              <div class="items__item" v-for="color in colors" :key="color">
                <button
                  :style="{ backgroundColor: color }"
                  :class="`items__button ${ selectedSleeveItemColor1 === color && 'is-selected' }`"
                  @click="changeSleeveItemColor1(color)"
                >
                </button>
              </div>
            </div>
          </section>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ThumbAreaMark from '../images/thumb/area/mark/ThumbAreaMark'                     // マークのエリア画像
import ThumbPartMark from '../images/thumb/part/mark/ThumbPartMark'                     // マークのパーツ画像
import MarkElementImage from '../images/item/MarkElementImage'
import MarkChestBothSidesItemImage from '../images/item/MarkChestBothSidesItemImage'
import MarkChestOneSideItemImage from '../images/item/MarkChestOneSideItemImage'
import MarkNumberItemImage from '../images/item/MarkNumberItemImage'
import MarkBackNameItemImage from '../images/item/MarkBackNameItemImage'
import MarkSleeveJapaneseItemImage from '../images/item/MarkSleeveJapaneseItemImage'
import MarkSleeveEnglishItemImage from '../images/item/MarkSleeveEnglishItemImage'
import { mapState, mapMutations } from 'vuex'
export default {
  components: {
    ThumbAreaMark,
    ThumbPartMark,
    MarkElementImage,
    MarkChestBothSidesItemImage,
    MarkChestOneSideItemImage,
    MarkNumberItemImage,
    MarkBackNameItemImage,
    MarkSleeveJapaneseItemImage,
    MarkSleeveEnglishItemImage
  },
  computed: {
    ...mapState({
      data: state => state.mark.data,
      colors: state => state.mark.colors,
      selectedArea: state => state.mark.selectedArea,
      selectedPart: state => state.mark.selectedPart,
      selectedElement: state => state.mark.selectedElement,
      selectedChestItem: state => state.mark.selectedChestItem,
      selectedChestItemColor1: state => state.mark.selectedChestItemColor1,
      selectedChestItemColor2: state => state.mark.selectedChestItemColor2,
      selectedChestItemColor3: state => state.mark.selectedChestItemColor3,
      selectedChestNumberItem: state => state.mark.selectedChestNumberItem,
      selectedChestNumberItemColor1: state => state.mark.selectedChestNumberItemColor1,
      selectedBackItem: state => state.mark.selectedBackItem,
      selectedBackItemColor1: state => state.mark.selectedBackItemColor1,
      selectedBackItemColor2: state => state.mark.selectedBackItemColor2,
      selectedBackNumberItem: state => state.mark.selectedBackNumberItem,
      selectedBackNumberItemColor1: state => state.mark.selectedBackNumberItemColor1,
      selectedSleeveItem: state => state.mark.selectedSleeveItem,
      selectedSleeveItemColor1: state => state.mark.selectedSleeveItemColor1,
      selectedSleeveItemColor2: state => state.mark.selectedSleeveItemColor2,
    }),
    currentParts: function() { 
      return this.data.parts.filter(part => part.area_id === this.selectedArea.id)
    },
    currentElements: function() { 
      return this.data.elements.filter(element => {
        if (element.part_id) {
          return this.selectedPart.some(part => part.id === element.part_id) && element.area_id === this.selectedArea.id
        } else {
          return element.area_id === this.selectedArea.id
        }
      })
    },
    chestMarkBothSidesItems: function() { 
      return this.data.items.both_sides
    },
    chestMarkOneSideItems: function() { 
      return this.data.items.one_side
    },
    chestNumberItems: function() { 
      return this.data.items.chest_number
    },
    backNumberItems: function() { 
      return this.data.items.back_number
    },
    backNameItems: function() { 
      return this.data.items.back_name
    },
    sleeveJapaneseItems: function() { 
      return this.data.items.japanese
    },
    sleeveEnglishItems: function() { 
      return this.data.items.english
    },
  },
  methods: {
    ...mapMutations({
      changeArea: 'mark/changeArea',
      changePart: 'mark/changePart',
      changeElement: 'mark/changeElement',
      changeChestItem: 'mark/changeChestItem',
      changeChestItemColor1: 'mark/changeChestItemColor1',
      changeChestItemColor2: 'mark/changeChestItemColor2',
      changeChestItemColor3: 'mark/changeChestItemColor3',
      changeChestNumberItem: 'mark/changeChestNumberItem',
      changeChestNumberItemColor1: 'mark/changeChestNumberItemColor1',
      changeBackItem: 'mark/changeBackItem',
      changeBackItemColor1: 'mark/changeBackItemColor1',
      changeBackItemColor2: 'mark/changeBackItemColor2',
      changeBackNumberItem: 'mark/changeBackNumberItem',
      changeBackNumberItemColor1: 'mark/changeBackNumberItemColor1',
      changeSleeveItem: 'mark/changeSleeveItem',
      changeSleeveItemColor1: 'mark/changeSleeveItemColor1',
      changeSleeveItemColor2: 'mark/changeSleeveItemColor2',
    }),
    handleChangePart: function(part) {
      this.changePart(part)
    },
    handleChangeElement: function(element) {
      this.changeElement(element)
    },
    isPartSelected: function(_part) {
      return this.selectedPart.some(part => part.id === _part.id)
    },
    isElementSelected: function(_element) {
      return this.selectedElement.some(element => element.id === _element.id)
    },
    isContainPartSlug: function(slug) {
      return this.selectedPart.some(part => part.slug === slug)
    },
    isContainElementSlug: function(slug) {
      return this.selectedElement.some(element => element.slug === slug)
    }
  }
}
</script>